import Section from "@/components/ui/section";
import React from "react";
import Link from "next/link";
import Image from "next/image";
export default function JoinUs({ teamButton = true }) {
  return (
    <Section variant="flat">
      <div className="flex md:flex-row flex-col items-center mx-auto gap-6 md:mb-24 mb-16 lg:mt-16">
        {/* First image, hidden on mobile */}
        <div className="relative lg:h-[250px] lg:w-[250px] w-[120px] h-[120px]">
          <Image
            src="/images/icons/tv.webp"
            alt="icon"
            sizes="(max-width: 479px) 300px, 300px"
            className="w-full h-full object-contain"
            fill
          />
        </div>

        {/* Text section */}
        <div className="flex flex-col w-fit items-center justify-center gap-2">
          <p className="text-[#292929]/70 mb-4 font-havletica md:text-lg text-base">
            Join Us
          </p>
          <p className="leading-tight text-center lg:text-[45px] md:text-[30px] text-[24px] font-havletica font-light text-gray-900 mb-6">
            BELIEVE IN THE <br />
            SAME THINGS WE DO?
          </p>
          <div className="flex justify-center items-center gap-20">
            <Link
              href="/careers"
              className="text-darkGrey hover:text-darkGrey/50 underline transition-all duration-300 ease text-sm"
            >
              Culture + Careers
            </Link>
            {teamButton && (
              <Link
                href="/culture"
                className="text-darkGrey hover:text-darkGrey/50 underline transition-all duration-300 ease text-sm"
              >
                Meet The Team
              </Link>
            )}
          </div>
        </div>

        {/* Second image, visible on all screens */}
        <div className="relative lg:h-[250px] lg:w-[250px] w-[120px] h-[120px] hidden md:flex">
          <Image
            src="/images/icons/frame.webp"
            alt="icon"
            sizes="(max-width: 479px) 300px, 300px"
            className="w-full h-full object-contain"
            fill
          />
        </div>
      </div>
    </Section>
  );
}
